import React from "react";
import styled from "styled-components";
import { func, string } from "prop-types";
import { useRouter } from "next/router";

import MoreInformation from "../shared/MoreInformation";
import TestDrivePointLogo from "./FilterResultItems/TestDrivePointLogo";
import Typography from "../shared/Typography";

import gtm from "@gtm/core";
import { testDriveType } from "@types";
import { TEST_DRIVE_TYPE_ID } from "@shared/constants";

import {
  testDriveClickedResultDessaiUpdateUrlEvent,
  testDriveClickedResultFnacUpdateUrlEvent,
  testDriveFree2MoveUpdateUrlEvent,
  testDriveMoreInfoEvent,
} from "@gtm/events/testdrive";

import {
  desktop,
  color,
  prop,
  fontSize,
  fontWeight,
  font,
} from "../shared/utils";

const Container = styled.div`
  width: 100%;
  color: ${color("black")};
  padding: 0 1rem 1rem 0;
  display: flex;
  align-items: flex-start;

  ${desktop`
    width: 50%;
  `}
`;

const IconContainer = styled.div`
  cursor: pointer;
  min-width: 40px;
  margin-right: 15px;
`;

const Title = styled.h3`
  align-items: center;
  color: ${prop("color")};
  cursor: pointer;
  display: flex;
  font-weight: ${fontWeight("bold")};
  font-size: ${fontSize("md")};
  font-family: ${font("citroen")};
  margin: 0 0 2rem 0;
  text-transform: uppercase;
`;

const DescriptionBlock = styled.div`
  margin: 0;
`;

const TestDriveType = ({ testDriveType, setTypeFilter, affiliation }) => {
  const {
    colorHexa,
    label,
    description,
    additionalDescription,
  } = testDriveType;

  const router = useRouter();

  const gtmEvent = eventAction =>
    gtm.fire(
      testDriveMoreInfoEvent({
        action: eventAction,
        label,
      })
    );

  const changeTypeFilter = () => {
    setTypeFilter(testDriveType.id);

    switch (testDriveType.id) {
      case TEST_DRIVE_TYPE_ID.STORE:
        gtm.fire(
          testDriveClickedResultDessaiUpdateUrlEvent({
            pageTitle: router.asPath,
            affiliation,
          })
        );
        return;

      case TEST_DRIVE_TYPE_ID.FNAC_DARTY:
        gtm.fire(
          testDriveClickedResultFnacUpdateUrlEvent({
            pageTitle: router.asPath,
            affiliation,
          })
        );
        return;

      case TEST_DRIVE_TYPE_ID.F2M:
        gtm.fire(
          testDriveFree2MoveUpdateUrlEvent({
            pageTitle: router.asPath,
            affiliation,
          })
        );
        return;
    }
  };

  return (
    <Container>
      <IconContainer onClick={changeTypeFilter}>
        <TestDrivePointLogo testDriveType={testDriveType} />
      </IconContainer>
      <div>
        <Title color={`#${colorHexa}`} onClick={changeTypeFilter}>
          {label}
        </Title>
        <DescriptionBlock>
          <Typography size="sm">{description}</Typography>
          <MoreInformation
            isHtmlStringContent
            gtmEvent={gtmEvent}
            label={label}
            expansionMode="above"
          >
            {additionalDescription}
          </MoreInformation>
        </DescriptionBlock>
      </div>
    </Container>
  );
};

TestDriveType.propTypes = {
  testDriveType: testDriveType.isRequired,
  setTypeFilter: func,
  affiliation: string,
};

export default TestDriveType;
